import { useEffect, useState, useMemo } from "react";
import toast from "react-hot-toast";
import NewPatientFast from "./Modals/NewPatientFast";

const SearchBar = ({ data, setSelected, value, placeholder, setOpen }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [newPatient, setNewPatient] = useState(false);

  // Usamos useMemo para calcular los datos filtrados de manera eficiente
  const filteredData = useMemo(() => {
    if (!searchTerm) return [];

    const searchTermLower = searchTerm.toLowerCase().trim();
    const searchTerms = searchTermLower.split(/\s+/); // Divide por espacios

    return (
      data?.filter((item) => {
        // Check if persona exists and has the required properties
        if (!item?.persona) return false;

        const nombre = item.persona.nombre?.toLowerCase() || "";
        const apellidos = item.persona.apellidos?.toLowerCase() || "";
        const nombreCompleto = `${nombre} ${apellidos}`;
        const ci = item.persona.ci?.toLowerCase() || "";

        // Coincidencia exacta
        if (
          nombreCompleto.includes(searchTermLower) ||
          ci.includes(searchTermLower)
        ) {
          return true;
        }

        // Coincidencia con todos los términos
        return searchTerms.every(
          (term) =>
            nombre.includes(term) ||
            apellidos.includes(term) ||
            ci.includes(term)
        );
      }) ?? []
    );
  }, [searchTerm, data]);

  const handleSearch = (event) => {
    const term = event.target.value;
    setSearchTerm(term);

    if (term.length === 0) {
      setSelected(null);
    }
  };

  const handleBlur = () => {
    setTimeout(() => {
      if (newPatient) {
        setNewPatient(false);
      }
    }, 400);
  };

  const handleSelect = (item) => {
    setSelected(item);
    setSearchTerm(
      `${
        item?.persona?.ci?.length > 8
          ? item?.persona?.ci?.slice(0, 8)
          : item?.persona?.ci
      } - ${item?.persona?.nombre} ${item?.persona?.apellidos}`
    );
  };

  return (
    <div className="">
      <input
        type="text"
        placeholder={placeholder}
        value={searchTerm ? searchTerm : value}
        onChange={handleSearch}
        onFocus={() => setNewPatient(true)}
        onBlur={handleBlur}
        className="relative w-full bg-white text-sm my-3 p-4 border rounded-lg border-border -z-1"
      />
      {(filteredData?.length > 0 || newPatient) && (
        <ul className="max-h-40 border absolute rounded-lg z-50 bg-white overflow-y-scroll">
          {filteredData?.map((item, index) => (
            <li
              key={item.id}
              onMouseDown={() => handleSelect(item)}
              className="border-b py-2 px-5 z-50"
            >
              {`${
                item.persona.ci.length > 8
                  ? item.persona.ci.slice(0, 8)
                  : item.persona.ci
              } - ${item.persona.nombre} ${item.persona.apellidos}`}
            </li>
          ))}
          {newPatient && (
            <li
              onMouseDown={() => {
                setOpen(true);
              }}
              className="bg-text font-semibold px-5 py-2 cursor-pointer"
            >
              {" "}
              + Nuevo Paciente . . .
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default SearchBar;
